import React from "react";

export interface IconProps {
  width?: number;
  height?: number;
  color?: string;
}

export default function CampaignIcon(props: IconProps): JSX.Element {
  const { width, height, color } = props;
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width || "20"}
      height={height || "15.998"}
      viewBox="0 0 20 15.998"
    >
      <g id="Campaign" transform="translate(0 -0.055)">
        <path
          id="Campaign-2"
          data-name="Campaign"
          d="M14,13.609c.4-.531.8-1.072,1.2-1.609.963.719,2.213,1.66,3.2,2.4-.4.527-.8,1.068-1.2,1.6C16.215,15.26,14.965,14.318,14,13.609ZM3,15V11H2A2.006,2.006,0,0,1,0,9V7A2.006,2.006,0,0,1,2,5H6l5-3V14L6,11H5v4ZM2,9H6.551l.482.289L9,10.467V5.525L7.033,6.711,6.551,7H2ZM12,4.65a4.479,4.479,0,0,1,0,6.686ZM16,9V7h4V9ZM14,2.4c.963-.719,2.213-1.66,3.2-2.4.4.525.8,1.066,1.2,1.6-.986.75-2.236,1.682-3.2,2.4C14.8,3.467,14.4,2.93,14,2.4Z"
          transform="translate(0 0.055)"
          fill={color || "#bbb"}
        />
      </g>
    </svg>
  );
}
